import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class StampIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16"><path d="M17.4 14.255h-.6V4.075c0-.16-.134-.29-.3-.29h-4.535c.057-.19.093-.385.11-.582H17.4v11.052zm-1.2 1.163H.6V9.02h4.2c.166 0 .3-.13.3-.291V4.366h1.165L7.8 7.342a3.195 3.195 0 0 1-1.602 2.736l-1.181.687s-.12.083-.135.097a.273.273 0 0 0-.082.194V12.8c0 .16.134.29.3.29h.6v1.164h6.6v-1.163h.6c.166 0 .3-.13.3-.291v-1.745a.276.276 0 0 0-.09-.2 5.365 5.365 0 0 0-.13-.092l-1.179-.686A3.195 3.195 0 0 1 10.2 7.342l1.535-2.976H16.2v11.052zM1.8 3.203h4.126c.016.197.052.392.109.581H4.8a.305.305 0 0 0-.219.092L1.8 6.753v-3.55zm4.383 7.562l.323-.188a3.79 3.79 0 0 0 1.887-3.012h1.214a3.79 3.79 0 0 0 1.887 3.012l.323.188H6.183zM17.7 2.62h-5.645C11.865 1.125 10.555 0 9 0 7.445 0 6.134 1.125 5.945 2.621H1.5c-.166 0-.3.13-.3.29v4.462L.08 8.53a.286.286 0 0 0-.08.199v6.98c0 .16.134.291.3.291h16.2c.166 0 .3-.13.3-.29v-.873h.9c.166 0 .3-.13.3-.291V2.912c0-.16-.134-.29-.3-.29z" fill="#8d979a"/></svg>
        )
    }
}

export default withCssClassName(StampIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/stamp-icon.js